import { Box, IconButton } from '@material-ui/core'
import { AddBox, Visibility as ViewIcon } from '@material-ui/icons'
import CommercialIcon from 'assets/Commercial/Sales'
import TickIcon from 'assets/Commercial/Tick'
import tableIcons, { options } from 'components/universal/table_attributes'
import PartSalesServices from 'lib/services/api/commercial/parts'
import { getColors, getOrganisationId } from 'lib/utils/common_utils'
import MaterialTable from 'material-table'
import React, { useEffect, useState } from 'react'
import ManageCoreDetails from 'views/Commercial/Parts/CoreExchange/SharedComponents/ManageCoreDetails'




export default function CoreTable(props) {
    const { salesId } = props
    const [data, setData] = useState([])
    const [action, setAction] = useState(null)
    const [currentSelection, setCurrentSelection] = useState({})



    const getDetails = async () => {
        const params = {
            organisation_id: getOrganisationId(),
            sales_order_id: salesId

        }
        try {
            const response = await PartSalesServices.getAllCoreDetails(params)
            setData(response?.data)

        } catch (error) {

        }
    }
    useEffect(() => {
        if (salesId !== null) {


            getDetails()

        }
    }, [salesId])

    const renderStateIcon = (rowData) => {

        const Icon = {
            "Quote": <CommercialIcon fill={getColors("amber")} />,
            "In Progress": <CommercialIcon fill={getColors("green")} />,
            "Complete": <TickIcon fill={getColors("green")} />,



        }

        return Icon[rowData?.parent_status]

    }


    const tableOptions = {
        ...options,
        paging: false,
        search: false,
        toolbar: false
    }
    const columns = [
        {
            title: "State",
            field: "part_number",
            width: "15%",
            render: (rowData) => renderStateIcon(rowData)
        },

        {
            title: "Part #",
            field: "part",
            width: "15%",
            headerStyle: {
                textAlign: "left",
                paddingLeft: "15px"
            },
            cellStyle: {
                textAlign: "left",
                paddingLeft: "15px"
            }
        },
        {
            title: "Description",
            field: "description",
            width: "15%",
            headerStyle: {
                textAlign: "left",

            },
            cellStyle: {
                textAlign: "left",

            }
        },
        {
            title: "Unit Value",
            field: "unit_cost"
        }, {
            title: "Quantity",
            field: "quantity"
        }, {
            title: "Core value",
            field: "core_value"
        },


        {
            title: "Shipping",
            field: "shipping"
        }, {
            title: "Total",
            field: "total"
        },


        {
            title: "Currency",
            field: "currency"
        },
        {
            title: "Action",
            field: "",
            render: (rowData) => <IconButton onClick={() => {
                setAction("view")
                setCurrentSelection({ sales_order_id: salesId, ...rowData })
            }}>
                <ViewIcon fontSize='small' />

            </IconButton>
        },




    ]

    const handleClose = () => {
        setAction(null)
        getDetails()
    }
    const renderActionPages = (value) => {

        const page = {

            "view": <ManageCoreDetails
                handleClose={handleClose}
                currentSelection={currentSelection}
                permission={props?.permission}
                isInvoiceOpen={true} />

        }

        return page[value]


    }




    return (
        <Box mb={"20px"}>

            <MaterialTable
                options={tableOptions}
                icons={tableIcons}
                data={data || []}
                columns={columns}
                isLoading={""}
                title={""}



            />


            {action && renderActionPages(action)}



        </Box>
    )
}
